import { mapNull } from "@core/prelude";

// TODO: need to review how we can better define interface/types
// and whether we export 'common' from lds component library for use

export interface SelectListOptionWithValue<T> {
  label: string;
  value: T;
}

export interface SelectListOptionWithSubtextAndValue<T> extends SelectListOptionWithValue<T> {
  subtext: string;
}

export interface SelectListOption extends SelectListOptionWithValue<string> {
  isDisabled?: boolean;
}
export interface SelectListOptionWithSubtext extends SelectListOptionWithSubtextAndValue<string> {
}

export function selectListOption(s: string): SelectListOption {
  return {
    label: s,
    value: s
  }
}

export function selectListOptionWithValue<T>(label: string, value: T) : SelectListOptionWithValue<T> {
  return { value: value, label: label }
}

export function generateSelectListOptions(stringOptions: string[]): SelectListOption[] {
  return stringOptions.map(selectListOption);
}

export function instanceOfSelectListOptionWithValue<T>(object: any): object is SelectListOptionWithValue<T> {
  return (typeof object === 'function') || (typeof object === 'object')
    && (object != null && 'label' in object && 'value' in object && (object['value'] as T) != null);
}

export function instanceOfSelectListOptionWithSubtextAndValue<T>(object: any): object is SelectListOptionWithSubtextAndValue<T> {
  return (typeof object === 'function') || (typeof object === 'object')
    && (object != null && 'label' in object && 'value' in object && (object['value'] as T) != null && 'subtext' in object);
}

export function instanceOfSelectListOptionWithSubtext(object: any): object is SelectListOptionWithSubtext {
  return instanceOfSelectListOptionWithSubtextAndValue<string>(object);
}

export function instanceOfSelectListOption(object: any): object is SelectListOption {
  return (typeof object === 'function') || (typeof object === 'object')
    && (object != null && 'label' in object && 'value' in object && typeof object['value'] === 'string');
}

export function selectListOptionValue<T>(x: any): T {
  return instanceOfSelectListOptionWithValue(x) ? x.value : x;
}

export const yesOrNo: SelectListOption[] = [ { value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }]

export function yesOrNoToBoolean(yesOrNo: string | null): boolean | null {
  return mapNull(x => x == 'Yes', yesOrNo)
}

export function booleanToYesOrNo(b: boolean | null): string | null {
  return mapNull(x => x ? 'Yes' : 'No', b)
}
